// Presentation boundary for an existing cart with commercially held products.
// Empty carts are also blocked inside their own cart component.
// This does not replace Shopify/app validation and never changes cart lines.
const summarySelector = '.cart__summary, .cart-summary, .cart-drawer__summary';
const heldMarkerSelector = '[data-drako-cart-held="true"]';
const emptyMarkerSelector = '[data-drako-cart-empty="true"]';
const nativeCheckoutSelector = 'button[name="checkout"][form="cart-form"]';
const codSelector = '#cart-wrapper #rsi_buy_now_button';

function heldSummaryForControl(control) {
  if (!(control instanceof Element)) return null;
  // Releasit uses the same ID on recommended product cards; leave those controls alone.
  if (control.closest('product-card, product-card-link')) return null;
  const component = control.closest('cart-items-component');
  if (component?.querySelector(emptyMarkerSelector)) return component;
  const summary = control.closest(summarySelector);
  return summary?.querySelector(heldMarkerSelector) ? summary : null;
}

function cancelPurchase(event, summary) {
  event.preventDefault();
  event.stopImmediatePropagation();
  const notice = summary.querySelector('.drako-cart-hold-notice')
    || summary.querySelector('.cart-items__empty-button');
  notice?.focus();
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const control = event.target.closest(`${nativeCheckoutSelector}, ${codSelector}`);
  const summary = heldSummaryForControl(control);
  if (summary) cancelPurchase(event, summary);
}, true);

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  if (!(event.target instanceof Element)) return;
  const control = event.target.closest(codSelector);
  const summary = heldSummaryForControl(control);
  if (summary) cancelPurchase(event, summary);
}, true);

document.addEventListener('submit', (event) => {
  if (!(event.target instanceof HTMLFormElement)) return;
  // An ordinary cart update, quantity input or remove action must keep working.
  if (!(event.submitter instanceof Element) || !event.submitter.matches('[name="checkout"]')) return;
  const component = event.target.closest('cart-items-component');
  const summary = heldSummaryForControl(event.submitter)
    || (component?.querySelector(emptyMarkerSelector) ? component : null)
    || [...(component?.querySelectorAll(summarySelector) || [])]
      .find((candidate) => candidate.querySelector(heldMarkerSelector));
  if (summary) cancelPurchase(event, summary);
}, true);
